import { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      const r = await api.post("/newsletter/subscribe", { email });
      toast.success("Letter on its way", {
        description: r.data.sent
          ? `Check ${email} for our perfume letter and the Ambdrop story.`
          : "You're subscribed. Our letter will reach you shortly.",
      });
      setEmail("");
    } catch (err) {
      toast.error("Couldn't subscribe", {
        description: err?.response?.data?.detail || "Please try again in a moment.",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <footer
      data-testid="site-footer"
      className="mt-32 border-t border-[#2D2622] bg-[#1F1A17]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 grid grid-cols-2 md:grid-cols-12 gap-12">
        <div className="col-span-2 md:col-span-5">
          <p className="font-serif-display text-4xl md:text-5xl leading-none gold-shimmer">
            Ambdrop
          </p>
          <p className="mt-6 text-sm leading-relaxed text-[#B0A496] max-w-sm">
            A small house of fragrances composed in India. Slow craft, raw materials,
            scents that earn their place on your dresser.
          </p>
          <div className="mt-8 flex items-center gap-5 text-[#D4AF37]">
            <a data-testid="social-ig" href="#" aria-label="Instagram"><Instagram strokeWidth={1.2} size={18} /></a>
            <a data-testid="social-fb" href="#" aria-label="Facebook"><Facebook strokeWidth={1.2} size={18} /></a>
            <a data-testid="social-tw" href="#" aria-label="Twitter"><Twitter strokeWidth={1.2} size={18} /></a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-[11px] tracking-overline uppercase text-[#D4AF37] mb-5 font-bold">Discover</p>
          <ul className="space-y-3 text-sm text-[#F4EAD9]">
            <li><Link data-testid="f-link-shop" to="/shop" className="editorial-link">All Fragrances</Link></li>
            <li><Link data-testid="f-link-best" to="/shop?best=1" className="editorial-link">Best Sellers</Link></li>
            <li><Link data-testid="f-link-men" to="/shop?category=For%20Men" className="editorial-link">For Him</Link></li>
            <li><Link data-testid="f-link-women" to="/shop?category=For%20Women" className="editorial-link">For Her</Link></li>
          </ul>
        </div>

        <div className="col-span-2 md:col-span-4">
          <p className="text-[11px] tracking-overline uppercase text-[#D4AF37] mb-5 font-bold">Letters from the lab</p>
          <p className="text-sm text-[#B0A496] mb-4">
            Leave your email and we&apos;ll send our perfume letter and the Ambdrop story straight to your inbox.
          </p>
          <form
            data-testid="newsletter-form"
            onSubmit={subscribe}
            className="flex border border-[#D4AF37]"
          >
            <input
              data-testid="newsletter-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@somewhere.com"
              className="flex-1 min-w-0 bg-transparent px-4 py-3 text-sm placeholder:text-[#D4AF37] outline-none"
            />
            <button
              data-testid="newsletter-submit"
              disabled={sending}
              className="bg-[#D4AF37] text-[#15110F] px-5 text-[11px] tracking-overline uppercase hover:bg-[#B8941F] disabled:opacity-70 transition-colors font-bold inline-flex items-center gap-2"
            >
              {sending && <Loader2 size={12} className="animate-spin" />}
              Subscribe
            </button>
          </form>
        </div>
      </div>

      <div className="border-t border-[#2D2622]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-[11px] tracking-overline uppercase text-[#D4AF37] font-bold">
          <p>© {new Date().getFullYear()} Ambdrop. Composed in India.</p>
          <Link data-testid="footer-admin-link" to="/admin" className="hover:text-[#F4EAD9] transition-colors">Admin</Link>
          <p>Crafted slowly · Free shipping PAN India</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
